export const iconFontAwesomeMapsCartShopping = (
	<i className="fa-solid fa-cart-shopping"></i>
);
